(function () {
  var CONFIGS = [
    { btnId: 'ec-cart-shipping-calculate', inputId: 'ec-cep-input', resultId: 'ec-cart-shipping-result' },
    { btnId: 'ec-cart-drawer-shipping-calculate', inputId: 'ec-cart-drawer-cep-input', resultId: 'ec-cart-drawer-shipping-result' }
  ];

  function formatZipCode(input) {
    if (!input) return;
    var v = input.value.replace(/\D/g, '');
    input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5, 8) : v;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(value);
  }

  function runShippingCalculate(btnShipping) {
    if (!btnShipping || !btnShipping.id) return;

    var now = Date.now();
    if (btnShipping.dataset.lastCalc && (now - parseInt(btnShipping.dataset.lastCalc, 10)) < 800) return;
    btnShipping.dataset.lastCalc = String(now);

    var config = CONFIGS.find(function (c) { return c.btnId === btnShipping.id; });
    if (!config) return;

    var zipCodeInput = document.getElementById(config.inputId);
    var shippingResult = document.getElementById(config.resultId);
    if (!zipCodeInput || !shippingResult) return;

    formatZipCode(zipCodeInput);
    var zipCode = zipCodeInput.value.replace(/\D/g, '');
    if (zipCode.length !== 8) {
      shippingResult.innerHTML = '<div class="ec-shipping-error">CEP inválido. Certifique-se de inserir 8 dígitos.</div>';
      delete btnShipping.dataset.lastCalc;
      return;
    }
    zipCode = zipCode.slice(0, 5) + '-' + zipCode.slice(5);

    var container = shippingResult.closest('.ec-cart-footer') || document.body;
    shippingResult.innerHTML = '<div class="ec-shipping-loading" style="padding:0.5rem 0;">Calculando...</div>';

    var btnSpan = btnShipping.querySelector('span');
    var btnImg = btnShipping.querySelector('img.ec-shipping-loading');
    if (btnSpan) btnSpan.textContent = '';
    if (btnImg) btnImg.style.display = 'block';
    btnShipping.style.opacity = '0.7';
    btnShipping.style.pointerEvents = 'none';

    var province = '';
    fetch('https://viacep.com.br/ws/' + zipCode.replace('-', '') + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.uf) throw new Error('CEP não encontrado');
        province = data.uf;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) throw new Error('Carrinho vazio');
        return fetch(
          '/cart/shipping_rates.json?shipping_address[zip]=' + zipCode +
          '&shipping_address[country]=BR&shipping_address[province]=' + province
        ).then(function (r) { return r.json(); });
      })
      .then(function (data) {
        if (!data.shipping_rates || data.shipping_rates.length === 0) {
          shippingResult.innerHTML = "<div class='ec-shipping-error'>Nenhuma opção de frete disponível para este CEP.</div>";
          return;
        }
        var cepDigits = zipCode.replace(/\D/g, '');
        var spPrefixes = ['0650','0651','0652','0653','0654','1320','1321','060','061','062','063','064','087','088','090','091','092','093','095','096','097','098','099','01','02','03','04','05'];
        var isSP = spPrefixes.some(function (p) { return cepDigits.indexOf(p) === 0; });
        var subtotalEl = container.querySelector
          ? container.querySelector('.ec-cart-footer__subtotal-value, .ec-cart-footer__total-value')
          : null;
        var subtotalCents = subtotalEl
          ? parseInt(subtotalEl.getAttribute('data-cart-subtotal') || subtotalEl.getAttribute('data-cart-subtotal-sem-desconto') || '0', 10)
          : 0;
        var gratisSP = subtotalCents >= 24999 && isSP;
        var gratisBR = subtotalCents >= 39900;

        var html = data.shipping_rates.map(function (rate) {
          var price = parseFloat(rate.price);
          var isEco = (rate.name || '').toLowerCase().indexOf('econom') >= 0;
          var gratis = price === 0 || ((gratisSP || gratisBR) && isEco);
          var priceStr = gratis ? 'GRÁTIS' : 'R$ ' + price.toFixed(2).replace('.', ',');
          var effectivePrice = gratis ? 0 : price;
          var days = 'No mesmo dia';
          if (rate.delivery_days && rate.delivery_days[0] !== undefined) {
            var d = parseInt(rate.delivery_days[0]);
            days = d <= 0 ? 'No mesmo dia' : (d === 1 ? '1 dia útil' : d + ' dias úteis');
          } else if (rate.delivery_range && rate.delivery_range[0] !== undefined) {
            var mn = parseInt(rate.delivery_range[0]);
            var mx = parseInt(rate.delivery_range[1] || mn);
            days = mn === 0 && mx === 0 ? 'No mesmo dia'
              : mn === mx ? mn + ' dias úteis'
              : mn + ' a ' + mx + ' dias úteis';
          }
          return '<label class="ec-shipping-option">' +
            '<input type="radio" name="shipping-rate" value="' + effectivePrice + '" data-delivery="' + days + '" data-service="' + (rate.name || '') + '">' +
            '<span class="ec-shipping-option-content">' +
              '<span class="ec-shipping-delivery">' + days + '</span>' +
              '<span class="ec-shipping-price">' + priceStr + '</span>' +
              '<span class="ec-shipping-service">' + (rate.name || '') + '</span>' +
            '</span></label>';
        }).join('');

        shippingResult.innerHTML = '<div class="ec-shipping-options-wrapper">' + html + '</div>';
        shippingResult.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (this.checked) updateCartTotal(parseFloat(this.value), container);
          });
        });
      })
      .catch(function (err) {
        shippingResult.innerHTML = "<div class='ec-shipping-error'>Erro ao obter frete. Tente novamente.</div>";
        console.error('[ec-frete]', err);
      })
      .finally(function () {
        if (btnSpan) btnSpan.textContent = 'Calcular';
        if (btnImg) btnImg.style.display = 'none';
        btnShipping.style.opacity = '1';
        btnShipping.style.pointerEvents = '';
        delete btnShipping.dataset.lastCalc;
      });
  }

  function updateCartTotal(shippingPrice, container) {
    var totalEl = container && container.querySelector
      ? container.querySelector('.ec-cart-footer__total-value')
      : document.querySelector('.ec-cart-footer__total-value');
    if (!totalEl) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.ecApplyCartTotal === 'function') {
          window.ecApplyCartTotal(cart, shippingPrice);
          return;
        }
        var subtotalCents = typeof window.ecGetSubtotalSemDesconto === 'function'
          ? window.ecGetSubtotalSemDesconto(cart)
          : cart.items_subtotal_price || 0;
        var subtotal = subtotalCents / 100;
        var cupom = parseInt(cart.total_discount || 0, 10) / 100;
        var total = Math.max(0, subtotal + shippingPrice - cupom);

        totalEl.textContent = formatMoney(total);
        totalEl.setAttribute('data-cart-subtotal', subtotalCents);

        var subtotalEl = container.querySelector ? container.querySelector('.ec-cart-footer__subtotal-value') : null;
        if (subtotalEl) { subtotalEl.textContent = formatMoney(subtotal); subtotalEl.setAttribute('data-cart-subtotal-sem-desconto', subtotalCents); }
        var pixEl = container.querySelector ? container.querySelector('.ec-payment-pix-value') : null;
        if (pixEl) pixEl.textContent = formatMoney(total * 0.95);
        var instEl = container.querySelector ? container.querySelector('.ec-payment-installment-value') : null;
        if (instEl) instEl.textContent = formatMoney(total / 6);

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: Object.assign({}, cart, { source: 'shipping-calculator' }) }));
      })
      .catch(function (err) { console.error('[ec-frete] updateCartTotal:', err); });
  }

  window.ecCalculateShipping = function (btn) {
    runShippingCalculate(btn);
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#ec-cart-shipping-calculate, #ec-cart-drawer-shipping-calculate, [data-ec-calculate-shipping]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    runShippingCalculate(btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    var config = CONFIGS.find(function (c) { return c.inputId === input.id; });
    if (!config) return;
    e.preventDefault();
    var btn = document.getElementById(config.btnId);
    if (btn) runShippingCalculate(btn);
  }, true);

  document.addEventListener('input', function (e) {
    var config = CONFIGS.find(function (c) { return c.inputId === e.target.id; });
    if (config) formatZipCode(e.target);
  }, true);

  document.addEventListener('paste', function (e) {
    var config = CONFIGS.find(function (c) { return c.inputId === e.target.id; });
    if (!config) return;
    e.preventDefault();
    var pasted = (e.clipboardData || window.clipboardData || { getData: function() { return ''; } }).getData('text');
    var digits = String(pasted).replace(/\D/g, '');
    e.target.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5, 8) : digits;
  }, true);

  function closeFreteOnMobile(e) {
    if (e && e.detail && e.detail.source === 'shipping-calculator') return;
    var el = document.getElementById('ec-cart-drawer-frete-details');
    if (!el || el.querySelector('.ec-shipping-options-wrapper, .ec-shipping-error')) return;
    if (window.matchMedia('(max-width: 749px)').matches) el.removeAttribute('open');
  }

  document.addEventListener('cart:updated', function (e) {
    requestAnimationFrame(function () { requestAnimationFrame(function () { closeFreteOnMobile(e); }); });
  });
  document.addEventListener('cart:dom-updated', function (e) {
    requestAnimationFrame(function () { requestAnimationFrame(function () { closeFreteOnMobile(e); }); });
  });

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.hasAttribute('data-ec-frete-observer')) return;
    drawer.setAttribute('data-ec-frete-observer', '1');
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && drawer.classList.contains('active')) {
          CONFIGS.forEach(function (c) {
            var input = document.getElementById(c.inputId);
            if (input && input.value) formatZipCode(input);
          });
        }
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
  setTimeout(observeDrawer, 500);
})();
